import { render, staticRenderFns } from "./DataActionButtons.vue?vue&type=template&id=6a1e36b5"
import script from "./DataActionButtons.vue?vue&type=script&lang=js"
export * from "./DataActionButtons.vue?vue&type=script&lang=js"
import style0 from "./DataActionButtons.vue?vue&type=style&index=0&id=6a1e36b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports